<template>
  <!--  开户推荐人-->
  <div>
    <Progress progress="11" v-if="!isInstitutional"></Progress>
    <div class="contain" :class="{isInstitutional: isInstitutional}">
      <div class="header">
        <div class="title">{{ $t("open_reference.lang") }}</div>
        <div class="ipt-box" :class="{'focus':inputFocusId == 1}">
          <div class="ipt-main">
            <div class="val-box">
              <span class="label" v-if="recommended_by || inputFocusId == 1">{{ $t('open_reference.nav_title') }}</span>
              <van-field
                class="val"
                v-model="recommended_by"
                :placeholder="inputFocusId == 1 ? '' : $t('open_reference.nav_title')"
                @focus="inputFocus(1)"
                @blur="blurEvent"
              ></van-field>
            </div>
          </div>
        </div>
      </div>
    </div>
    <nav-buttons navigationType="back" @on-next="handRecommend"></nav-buttons>
  </div>
</template>
<script>
import { Field, Toast } from "vant";
import Progress from "../components/Progress.vue";
import navButtons from "../components/navButtons.vue";

export default {
  components: {
    VanField: Field,
    Progress,
    navButtons
  },
  data() {
    return {
      recommended_by: "",
      process_id: "",
      inputFocusId:null,
      isInstitutional: false,
      hasHkId: false
    };
  },
  created() {
    this.isInstitutional = this.$route.query.name == 'institutional';
    this.hasHkId = !!this.$route.query.hasHkId;
    if(!this.isInstitutional){
      this.handDetail();
    }
  },
  computed: {
    bgColor() {
      return this.$store.getters["common/bgColor"];
    }
  },
  methods: {
   handDetail() {
      const params = {
        step_code:'1,2-1'
      }
      this.$apis.accountSituationV2(params).then(res => {
        this.process_id = res?.process_info["1"]?.process_id;
        const { config_data } = res?.process_info?.["2-1"] || {};
        if (config_data) {
          const form = JSON.parse(config_data);
          this.recommended_by = form.recommended_by;
        }
      });
    },
    inputFocus(id){
     this.inputFocusId = id
    },
    blurEvent() {
      this.inputFocusId = ''
    },

    handRecommend() {
      const { recommended_by } = this;
      const toastLoading = Toast.loading({
        duration: 0,
        forbidClick: true,
        loadingType: "spinner",
        message: this.$t("common.loading_text")
      });
      if(!this.isInstitutional){
        const params = {
          process_id:this.process_id,
          step_code: "2-1",
          step_order: 2,
          config_data: { 
            recommended_by
          }
        };
        if (this.process_id) {
          this.$apis.supplementSaveApi(params).then(res => {
            if (res) {
              const next = () => {
                this.$router.push({ path: "/open-account/id-card-upload" }).finally(() => {
                  toastLoading.clear();
                });
              };
              if (this.hasHkId) {
                this.$apis.supplementSaveApi({
                  process_id: this.process_id,
                  step_code: '2-2',
                  step_order: 2,
                  config_data: { process_id: this.process_id }
                }).then(next);
              } else {
                next();
              }
            }
          });
        }
      }else{
        this.$apis.companySaveRecommendApi({
          recommended_by
        }).then(res =>{
          this.$router.push({
            path: '/open-account/institutional'
          }).finally(() => {
            toastLoading.clear();
          });
        })
      }


    }
  }
};
</script>

<style lang="less" scoped>
.contain {
  margin-top: 40px;
  &.isInstitutional{
    margin-top: 0;
  }
  .header {
    padding: 56px 32px 60px 32px;

    .title {
      font-size: 28px;
      color: #17161C;
    }

    .message {
      border: 1px solid rgba(23, 22, 28, 0.45);
      border-radius: 8px;
      margin-top: 22px;
      padding: 10px;
    }
  }
}

::v-deep .van-field__control::placeholder {
  color: #747377;
  font-size: 28px;
  font-weight: 400;
}
.form-label{
  font-size: 24px;
  margin-left: 20px;
  color: #747377;
}

.black-theme{
  .header{
    .title{
      color: #FFFFFF;
    }
    .ipt-box{
      &.focus{
        .ipt-main{
          &:after{
            border-color: rgba(255,255,255,1);
          }
        }
      }
      &.error{
        .ipt-main{
          &:after{
            border-color: #fd2626;
          }
        }
      }
      .ipt-main{
        &:after{
          border-color: rgba(255,255,255,0.25);
        }
        .label{
          color: #9D9D9F;
        }
        .icon-arrow{
          background: url("../../../assets/images/open-account/dark_icon.png") no-repeat;
          width: 32px;
          height: 32px;
          background-size: 100% 100%;
        }
        .val{
          color: #fff;
          ::v-deep{
            .van-cell__value input::placeholder {
              color: #9D9D9F !important;
            }
            textarea{
              color: #fff;
            }
          }
        }
      }
    }
  }
  /deep/ .van-field__control::placeholder{
    color: #9D9D9F;
  }
}
.ipt-box {
  margin-bottom: 24px;
  margin-top: 22px;
  &.focus{
    border-color: #17161C;
    .ipt-main{
      &:after{
        border-color: #17161C;
      }
      ::v-deep .van-cell{
        input {
          &::placeholder {
            font-size: 0;
          }
        }
      }
    }
  }
  &.error{
    .ipt-main {
      &:after {
        border-color: #FD2626;
      }
    }
  }
  .ipt-main {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 32px;
    min-height: 56px;
    position: relative;
    &:after{
      content: '';
      position: absolute;
      margin-top: -1px;
      top: -50%;
      left: -50%;
      width: 200%;
      height: 200%;
      border: 1px solid rgba(23, 22, 28, 0.25);
      transform: scale(0.5);
      border-radius: 20px;
    }
    .val-box {
      position: relative;
      flex: 1;
      display: flex;
      z-index: 1;
      flex-direction: column;
      line-height: 1;
      font-size: 32px;
      @keyframes labelAni{
        0%{
          font-size: 28px;
        }
        100%{
          font-size: 24px;
        }
      }
      .label {
        color: #747377;
        padding: 4px 0 20px;
        font-size: 24px;
        animation: labelAni .2s .1s linear both;
        &.placeholder {
          padding: 12px 0 6px 0;
          font-size: 28px;
          animation: none;
        }
      }
      ::v-deep .van-cell {
        min-height: 0px;
        font-size: 32px;
        line-height: 32px;
        input{
          &::placeholder {
            font-size: 28px;
            color: #747377;
            font-weight: normal;
          }
          &:focus ~ .van-field__body{
            background: red;
          }
        }
        textarea {
          font-size: 32px;
          line-height: 35px;
          min-height: 70px;
          color: #17161c;
        }
      }
      .val {
        padding: 0;
        line-height: 36px;
        color: #17161c;
        font-weight: 500;
      }
    }
    .icon-arrow {
      width: 32px;
      height: 32px;
      background: url("../../../assets/images/arrow-down.png") no-repeat;
      background-size: 100% 100%;
    }
  }
  .error {
    display: none;
    margin-top: 12px;
    color: #fd2626;
    font-size: 24px;
    &.show{
      display: block;
    }
    &.right{
      text-align: right;
    }
  }
  &.error{
    .ipt-main{
      border-color: #fd2626;
    }
    .error{
      display: block;
    }
  }
}

</style>
